import React from 'react';

import Collapsible from 'react-collapsible';
import PlusMinusIcon from '../../icons/PlusMinusIcon';
import accordions from './NewAssessmentAccordionsData';

function NewAssessmentAccordions() {
  return (
    <div className="row">
      <div className="accordions">
        {accordions.map(accordion => (
          <Collapsible
            tabIndex={0}
            trigger={(
              <div>
                <PlusMinusIcon option="plus" />
                {accordion.title}
              </div>
            )}
            triggerWhenOpen={(
              <div>
                <PlusMinusIcon option="minus" />
                {accordion.title}
              </div>
            )}
            key={accordion.title}
            easing="ease-in-out"
            contentInnerClassName="text"
          >
            {accordion.content}
          </Collapsible>
        ))}
      </div>
    </div>
  );
}

export default NewAssessmentAccordions;



// WEBPACK FOOTER //
// ./src/components/features/assessment/NewAssessmentAccordions.js